import React from 'react'
import Step from '../../components/Step'
import Button from '../../elements/Button'
import ButtonContainer from '../../elements/ButtonContainer'
import Input from '../../elements/Input'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const yearBuilt = fieldName('yearBuilt')
    

export const rules = {
    [yearBuilt]: [
        enforce.required("Required"),
        enforce.greaterThan(1800)("Year built must be after 1800"),
    ]
}


export default () => {
    const navigation = Resi.useNavigation();
    const validation = Resi.useValidation();

    async function next(){
        try{
            await validation.validate(rules)
            navigation.goToNext();
        }catch(e){}
    }

    return (
        <Step>
            <h2>What year was the building built? <HelpIcon label={yearBuilt} message=""/></h2>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Input autoFocus field={yearBuilt} type="year" caption="If unsure please enter an approximate year"/>
                </div>
            </div>
            
            <ButtonContainer>
                <Button label="Continue" icon="fas fa-chevron-right" type="primary" callback={ next } />
            </ButtonContainer>
        </Step>
    )
};
